import { isAxiosError } from "axios";

/**
 * ネストされたオブジェクト/配列から文字列メッセージを再帰的に収集する。
 */
const collectMessages = (value: unknown): string[] => {
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(collectMessages);
  if (value && typeof value === "object") {
    return Object.values(value).flatMap(collectMessages);
  }
  return [];
};

/**
 * Axiosエラーのレスポンスボディから、ユーザーに表示可能なエラーメッセージを抽出する。
 * DRFのバリデーションエラー（`{ field: ["msg"] }` のようなネスト構造）を走査し、
 * 含まれる文字列メッセージをすべて改行区切りで結合して返す。
 * Axiosエラーでない場合やレスポンスボディからメッセージを抽出できない場合はnullを返す。
 * @param {unknown} error - catchで捕捉したエラー
 * @returns {string | null} 抽出したエラーメッセージ。抽出できない場合はnull
 */
export const extractApiErrorMessage = (error: unknown): string | null => {
  if (!isAxiosError<unknown>(error)) return null;
  const data = error.response?.data;
  if (!data) return null;
  const messages = [...new Set(collectMessages(data).filter(Boolean))];
  return messages.length > 0 ? messages.join("\n") : null;
};
